// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"847":"69571904","892":"e1252040","961":"c5b5c980"}[chunkId] + ".chunk.css";
};